import RecipeImagePlaceholder from "./RecipeImagePlaceholder"
export default RecipeImagePlaceholder
